import BaseService from "@/services/BaseService";
import * as URI from "../branchScheme/constant";

const action = {
  async getBranchSchemeListAction({ commit }, payload) {
    let url = URI.BRANCH_SCHEME_LIST_URL.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setBranchSchemeList", response.data.data);
    return response.data.data;
  },
  async getBranchSchemeDetailAction({ commit }, payload) {
    const url = URI.BRANCH_SCHEME_DETAIL_URL.replace("{branchSchemeId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(
      url
    );
    commit("setBranchSchemeDetail", response.data.data);
    return response.data.data;
  },
  async saveBranchSchemeDataAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.BRANCH_SCHEME_HEADER_SAVE_URL,
      payload
    );
    return response.data.data;
  },
  updateBranchScheme({ commit }, payload) {
    commit("setBranchScheme", payload);
  },
  async listBranchSchemeLinesAction({ commit }, payload) {
    const url = URI.BRANCH_SCHEME_LINES_LIST_URL.replace("{id}", payload.id)
    .replace(
      "{currentPage}",
      payload.data.page.currentPage
    )
      .replace("{pageSize}", payload.data.page.pageSize)
      .replace("{value}", payload.data.sord.value)
      .replace("{sortOrder}", payload.data.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setBranchSchemeLinesList", response.data.data);
    return response.data.data;
  },
  async uploadBranchLinesCsv({ commit }, payload) {
    const url = URI.BRANCH_LINES_UPLOAD_CSV_URL.replace("{id}", payload.id);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response;
  },
  async downloadBranchLinesExcel({ commit }, payload) {
    let url = URI.BRANCH_LINES_EXCEL_URL.replace(
      "{id}",
      payload.id
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  updateLinesGridData({ commit }, payload) {
    commit("setLinesGridData", payload);
  },
  async updateBranchLinesAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().put(
      URI.BRANCH_LINES_UPDATE_URL,
      payload
    );
    return response.data;
  },
  async deleteBranchBudget({ commit }, payload) {
    const url = URI.DELETE_BRANCH_SCHEME_URL.replace(
      "{branchSchemeId}",
      payload.budgetNo
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async deleteBranchLinesAction({ commit }, payload) {
    const url = URI.DELETE_BRANCH_SCHEME_LINES_URL.replace(
      "{id}",
      payload.id
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
};

export default action;